import React, { useState } from 'react';
import classnames from 'classnames';
import { HelpCircle, WithSubRentals } from 'Utils/SvgIcons';

const SubrentalsLegend: React.FC = () => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div
      className={classnames({
        legend: true,
        open,
      })}
    >
      {open ? (
        <div>
          <button
            type='button'
            className='legendToggle'
            onClick={toggleOpen}
            aria-label='Close icon legend'
          >
            <HelpCircle />
          </button>
          <h4>Icon Legend</h4>
          <ul>
            <li>
              <WithSubRentals /> Subrental Status
            </li>
          </ul>
        </div>
      ) : (
        <button
          type='button'
          className='legendToggle'
          onClick={toggleOpen}
          aria-label='Open icon legend'
        >
          <HelpCircle />
        </button>
      )}
    </div>
  );
};

export default React.memo(SubrentalsLegend);
